export const FIT_TIER_STRONG = "strong";
export const FIT_TIER_GOOD = "good";
export const FIT_TIER_WEAK = "weak";
export const FIT_TIER_NOT_A_FIT = "not_a_fit";

export const FIT_TIER_LABELS: Record<string, string> = {
  [FIT_TIER_STRONG]: "Strong",
  [FIT_TIER_GOOD]: "Good",
  [FIT_TIER_WEAK]: "Weak",
  [FIT_TIER_NOT_A_FIT]: "Not a fit",
};

export const FIT_TIER_COLORS: Record<string, string> = {
  [FIT_TIER_STRONG]: "green",
  [FIT_TIER_GOOD]: "teal",
  [FIT_TIER_WEAK]: "gray",
  [FIT_TIER_NOT_A_FIT]: "red",
};

export const FIT_REASON_STATUS_MET = "met";
export const FIT_REASON_STATUS_PARTIAL = "partial";
export const FIT_REASON_STATUS_MISSING = "missing";
export const FIT_REASON_STATUS_UNKNOWN = "unknown";

export const FIT_REASON_STATUS_LABELS: Record<string, string> = {
  [FIT_REASON_STATUS_MET]: "Met",
  [FIT_REASON_STATUS_PARTIAL]: "Partial",
  [FIT_REASON_STATUS_MISSING]: "Missing",
  [FIT_REASON_STATUS_UNKNOWN]: "Unknown",
};

export const FIT_AXIS_LABELS: Record<string, string> = {
  role_family: "Role family",
  skills: "Skills",
  experience: "Experience",
  location: "Location",
  ctc: "CTC",
  availability: "Notice",
  languages: "Languages",
  education: "Education",
  vector: "Profile similarity",
};

export const CONTACT_CHANNEL_PHONE = "phone";
export const CONTACT_CHANNEL_WHATSAPP = "whatsapp";
export const CONTACT_CHANNEL_OTHER = "other";

export const CONTACT_CHANNEL_OPTIONS = [
  { value: CONTACT_CHANNEL_PHONE, label: "Phone" },
  { value: CONTACT_CHANNEL_WHATSAPP, label: "WhatsApp" },
  { value: CONTACT_CHANNEL_OTHER, label: "Other" },
] as const;

export const CONTACT_OUTCOME_INTERESTED = "interested";
export const CONTACT_OUTCOME_NOT_INTERESTED = "not_interested";
export const CONTACT_OUTCOME_NO_ANSWER = "no_answer";
export const CONTACT_OUTCOME_CALL_BACK = "call_back";
export const CONTACT_OUTCOME_WRONG_NUMBER = "wrong_number";

export const CONTACT_OUTCOME_OPTIONS = [
  { value: CONTACT_OUTCOME_INTERESTED, label: "Interested" },
  { value: CONTACT_OUTCOME_NOT_INTERESTED, label: "Not interested" },
  { value: CONTACT_OUTCOME_NO_ANSWER, label: "No answer" },
  { value: CONTACT_OUTCOME_CALL_BACK, label: "Call back" },
  { value: CONTACT_OUTCOME_WRONG_NUMBER, label: "Wrong number" },
] as const;

export const CONTACT_OUTCOME_LABELS: Record<string, string> = Object.fromEntries(
  CONTACT_OUTCOME_OPTIONS.map((row) => [row.value, row.label]),
);

export const INTAKE_CHANNEL_WHATSAPP = "whatsapp";
export const INTAKE_CHANNEL_LINKEDIN = "linkedin";
export const INTAKE_CHANNEL_INSTAGRAM = "instagram";
export const INTAKE_CHANNEL_EMAIL = "email";
export const INTAKE_CHANNEL_OTHER = "other";
export const INTAKE_CHANNEL_WEBSITE = "website";
export const INTAKE_CHANNEL_UNTAGGED_LABEL = "Direct /apply";
export const CHANNEL_COLUMN_LABEL = "Channel";

export const INTAKE_CHANNEL_LABELS: Record<string, string> = {
  [INTAKE_CHANNEL_WHATSAPP]: "WhatsApp",
  [INTAKE_CHANNEL_LINKEDIN]: "LinkedIn",
  [INTAKE_CHANNEL_INSTAGRAM]: "Instagram",
  [INTAKE_CHANNEL_EMAIL]: "Email",
  [INTAKE_CHANNEL_OTHER]: "Other",
  [INTAKE_CHANNEL_WEBSITE]: "Website",
};

export function intakeChannelLabel(channel: string | null | undefined): string {
  if (!channel) return INTAKE_CHANNEL_UNTAGGED_LABEL;
  return INTAKE_CHANNEL_LABELS[channel] ?? channel;
}

export const SUBMISSION_ATTESTATION_VERSION = "v1";
export const SUBMISSION_ATTESTATION_COPY =
  "I personally contacted {candidate} on {date} via {channel}, and they confirmed they are interested in {job_title} and agree to be submitted. I understand false confirmations can lead to rejected submissions and account action.";

export const CANDIDATE_LIST_SORT_BEST_MATCH = "best_match";
export const CANDIDATE_LIST_SORT_RECENT_CONTACT = "recent_contact";
export const CANDIDATE_LIST_SORT_NEWEST = "newest";
export const CANDIDATE_LIST_SORT_NAME = "name";

export const CANDIDATE_LIST_SORT_OPTIONS = [
  { value: CANDIDATE_LIST_SORT_BEST_MATCH, label: "Best match" },
  { value: CANDIDATE_LIST_SORT_RECENT_CONTACT, label: "Recent contact" },
  { value: CANDIDATE_LIST_SORT_NEWEST, label: "Newest" },
  { value: CANDIDATE_LIST_SORT_NAME, label: "Name" },
] as const;

export const MATCH_TIER_FILTER_STRONG = FIT_TIER_STRONG;
export const MATCH_TIER_FILTER_GOOD = FIT_TIER_GOOD;
export const MATCH_TIER_FILTER_ANY = "any";

export const MATCH_TIER_FILTER_OPTIONS = [
  { value: MATCH_TIER_FILTER_ANY, label: "All matches" },
  { value: MATCH_TIER_FILTER_STRONG, label: "Strong" },
  { value: MATCH_TIER_FILTER_GOOD, label: "Strong or good" },
] as const;

export const CONTACT_FILTER_NEVER = "never";
export const CONTACT_FILTER_ANY = "any";

export const CONTACT_FILTER_OPTIONS = [
  { value: CONTACT_FILTER_ANY, label: "Any contact" },
  { value: CONTACT_FILTER_NEVER, label: "Never contacted" },
] as const;

export const JOB_LIST_SORT_NEWEST = "newest";
export const JOB_LIST_SORT_POOL_MATCHES = "pool_matches";

export const JOB_LIST_SORT_OPTIONS = [
  { value: JOB_LIST_SORT_NEWEST, label: "Newest" },
  { value: JOB_LIST_SORT_POOL_MATCHES, label: "Most matches from your pool" },
] as const;

export const INTAKE_MIN_SKILLS = 3;
export const INTAKE_MIN_SKILLS_WITH_RESUME = 1;
export const FIT_REASON_PREVIEW_COUNT = 3;
export const FIT_REASON_FULL_COUNT = 99;
export const MATCH_TABLE_JOB = "Job";
export const MATCH_TABLE_CANDIDATE = "Candidate";
export const MATCH_TABLE_FIT = "Fit";
export const MATCH_TABLE_WHY = "Why";
export const MATCH_TABLE_CONTACT = "Contact";
export const MATCH_TABLE_ACTION = "Action";
export const CANDIDATE_PROFILE_COLUMN = "Profile";
export const CANDIDATE_PIPELINE_COLUMN = "Pipeline";
export const CANDIDATE_MATCHES_COLUMN = "Matches";
export const CANDIDATE_RECRUITER_COLUMN = "Recruiter";
export const CANDIDATE_VERIFIED_TOOLTIP = "User verified";
export const INTAKE_SEGMENT_LABEL = "What kinds of roles are you open to?";
export const INTAKE_SEGMENT_LABEL_JOB = "Which role families describe your experience?";
export const INTAKE_SEGMENT_DESCRIPTION = "Optional if you uploaded a resume — we infer the occupation. Otherwise pick at least one.";
export const INTAKE_SEGMENT_DESCRIPTION_JOB = "This application will be considered for the role above only";
export const RELATIVE_MINUTE_MS = 60 * 1000;
export const RELATIVE_HOUR_MS = 60 * RELATIVE_MINUTE_MS;
export const RELATIVE_DAY_MS = 24 * RELATIVE_HOUR_MS;
export const RELATIVE_WEEK_DAYS = 7;

export const MATCHED_JOBS_TITLE = "Matched jobs";
export const MATCHED_JOBS_DESCRIPTION = "Open roles this candidate already fits. We notify you the moment a new one opens.";
export const MATCHED_JOBS_EMPTY_TITLE = "No open job fits yet";
export const MATCHED_JOBS_EMPTY_DESCRIPTION = "We will notify you the moment an open job matches this candidate.";
export const MATCHED_JOBS_ERROR_TITLE = "Could not load matches";
export const POOL_MATCHES_TITLE = "From your pool";
export const POOL_MATCHES_DESCRIPTION = "Candidates in your pool ranked for this job.";
export const POOL_MATCHES_EMPTY_TITLE = "No pool matches yet";
export const POOL_MATCHES_EMPTY_DESCRIPTION = "Grow your pool with your intake link. Strong matches will show up here.";
export const POOL_BADGE_TITLE_ONE = "Match";
export const POOL_BADGE_TITLE_MANY = "Matches";
export const POOL_BADGE_TOOLTIP =
  "Axiohire and Company Hr cannot see these candidates until you submit them!";
export const LOG_CONTACT_TITLE = "Log how it went";
export const LOG_CONTACT_PROMPT = "Log contact";
export const LOG_CONTACT_ACTION = "Save contact";
export const CONTACT_NEVER_LABEL = "Never contacted";
export const CONTACTED_PREFIX = "Contacted";
export const JOINED_PREFIX = "joined";
export const STRONG_FOR_JOBS_LABEL = "Strong for";
export const GOOD_FOR_JOBS_LABEL = "Good for";
export const MORE_MATCHES_ONE = "+{n} more match";
export const MORE_MATCHES_MANY = "+{n} more matches";
export const SUBMIT_ATTESTATION_LABEL = "I confirm this";
export const SUBMIT_NO_CONTACT_ALERT =
  "No contact logged yet. Call the candidate first.";
export const EXPLAIN_WITH_AI_LABEL = "Explain with AI";
export const EXPLAIN_WITH_AI_LOADING = "Loading explanation…";
export const EXPLAIN_WITH_AI_EMPTY = "No explanation yet.";
export const EXPLAIN_WITH_AI_FAILED = "Could not load explanation.";
export const FIT_EXPLANATION_TITLE = "Fit explanation";
export const LOG_CONTACT_LABEL = "Log contact";
export const ROLE_FAMILY_LABEL = "Role family";
export const ROLE_FAMILY_PLACEHOLDER = "Override occupation family";
export const WHATSAPP_CANDIDATE_LABEL = "WhatsApp";
export const SHARE_CHANNEL_WHATSAPP = "WhatsApp";
export const SHARE_CHANNEL_LINKEDIN = "LinkedIn";
export const SHARE_CHANNEL_INSTAGRAM = "Instagram";
export const SHARE_COPY_STORY_LABEL = "Copy link for Instagram";
export const SHARE_DOWNLOAD_QR_LABEL = "Download QR";
export const JOINED_PER_CHANNEL_LABEL = "Joined per channel";
export const CAMPAIGN_CANDIDATES_SUBTITLE = "Candidates who joined from public /apply campaigns.";
export const CAMPAIGN_CANDIDATES_SUBTITLE_ONE = "1 candidate joined from /apply campaigns.";
export const CAMPAIGN_CANDIDATES_SUBTITLE_MANY = "{count} candidates joined from /apply campaigns.";
export const CAMPAIGN_CANDIDATES_EMPTY_TITLE = "No campaign candidates yet";
export const CAMPAIGN_CANDIDATES_EMPTY_DESCRIPTION =
  "Candidates who join from /apply campaign links will show up here.";
export const CANDIDATES_EMPTY_TITLE = "No candidates yet";
export const CANDIDATES_EMPTY_ADD_DESCRIPTION = "Add candidates to your pool or share your intake link.";
export const CANDIDATES_EMPTY_POOL_DESCRIPTION = "No candidates from your recruiters yet.";

export function campaignCandidatesSubtitle(total: number): string {
  if (total === 1) return CAMPAIGN_CANDIDATES_SUBTITLE_ONE;
  return CAMPAIGN_CANDIDATES_SUBTITLE_MANY.replace("{count}", String(total));
}

export function attestationCopy(values: {
  candidate: string;
  date: string;
  channel: string;
  jobTitle: string;
}): string {
  const channelLabel =
    CONTACT_CHANNEL_OPTIONS.find((row) => row.value === values.channel)?.label ?? values.channel;
  return SUBMISSION_ATTESTATION_COPY.replace("{candidate}", values.candidate)
    .replace("{date}", values.date)
    .replace("{channel}", channelLabel)
    .replace("{job_title}", values.jobTitle);
}
